/*
 * File: smooth-height.ts
 * File Created: 2023-12-22 03:04:06
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-16 06:02:11
 * Modified By: Val Liu
 * -----
 */

import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";

@Component
export default class SmoothHeight extends Vue {
    @Ref() readonly wrapper!: HTMLDivElement;
    @Ref() readonly content!: HTMLDivElement;

    private observer: ResizeObserver | undefined;
    mounted() {
        this.$nextTick(() => {
            if (this.observer == null) {
                this.observer = new ResizeObserver((entries) => {
                    for (let entry of entries) {
                        const { height } = entry.contentRect;
                        // console.log(`Element's height is now: ${height}`);
                        // Handle height change
                        this.wrapper.style.height = `${height}px`;
                        this.wrapper.style.overflowY = "hidden";
                    }
                });
            }
            this.observer.observe(this.content);
        });
    }

    destroyed() {
        if (this.observer != null) this.observer.unobserve(this.content);
    }
}
